import React from 'react';

const ProfessionalAccounting = () => {
  return (
    <div>
      ProfessionalAccounting
      ProfessionalAccounting
    </div>
  );
}

export default ProfessionalAccounting;
